/* global axios */

const DEFAULT_API_VERSION = 'v1';

class PublicApiClient {
  constructor(resource, options = {}) {
    this.apiVersion = `/public/api/${options.apiVersion ||
      DEFAULT_API_VERSION}`;
    this.resource = resource;
  }

  get url() {
    return `${this.apiVersion}/${this.resource}`;
  }

  get() {
    return axios.get(this.url);
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  create(data) {
    return axios.post(this.url, data);
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, data);
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }
}

export default PublicApiClient;
